export default {
  title_one: 'Uso singolo, {{discount}}',
  title_other: '{{count}} utilizzi, {{discount}}',
  labels: {
    fixed_discount: '{{discount}} sconto totale',
    percentage_discount: 'Sconto percentuale',
  },
  buttons: {
    add_component: 'Aggiungi utilizzo',
  },
};
